/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import { useEffect, useState } from 'react';

const Params = {
  Page: 'page',
  PerPage: 'per_page',
  StartDate: 'start_date',
  EndDate: 'end_date',
  Type: 'type',
  Location: 'location',
  Audience: 'audience'
};

export const useFilterResults = ({
  endpoint,
  itemsPerPage: perPage,
  eventsId
}) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [itemsPerPage] = useState(Number(perPage) || 12);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [type, setType] = useState('');
  const [location, setLocation] = useState('');
  const [audience, setAudience] = useState('');
  const [viewMore, setViewMore] = useState(false);
  const [total, setTotal] = useState(0);

  const defaultFilters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    setPage(1);
    setStartDate(null);
    setEndDate(null);
    setType(null);
    setLocation(null);
    setAudience(null);
  };

  const fetchResults = async () => {
    setLoading(true);

    try {
      const { data } = await Axios.get(endpoint, {
        params: {
          events_id: eventsId,
          page,
          per_page: itemsPerPage,
          start_date: startDate,
          end_date: endDate,
          type,
          location,
          audience
        }
      });
      const { totalEvents, events } = data;
      setTotal(totalEvents);
      setResults(events);

      if (totalEvents > page * itemsPerPage) {
        setViewMore(true);
      } else {
        setViewMore(false);
      }
    } catch (error) {
      setResults([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    defaultFilters();
  }, []);

  useEffect(() => {
    if (!page) return;

    fetchResults();
  }, [page, startDate, endDate, type, location, audience]);

  const handleViewMore = () => {
    setPage(page + 1);
  };

  return {
    results,
    loading,
    page,
    setPage,
    setStartDate,
    setEndDate,
    setType,
    setLocation,
    setAudience,
    viewMore,
    handleViewMore,
    total
  };
};
